export const getErrorFoundMsg = (validCount: number, errCount: number): string => {
	return `${validCount} URLs were found and ${errCount} errors.`;
};

export const getUrlsFoundMsg = (count: number): string => {
	return `${count} URLs were found.`;
};
